import axios from "axios";
const uri = "https://www.lefisc.com.br/api/monitoramentoNCM/Cliente";
const uriAlteracoesDaNCM = "historicoNcm";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";
const uriNCM = "dadosNCM";

export default {
  async getDadosNCM(numNCM) {
    return axios
      .get(`${uri}/${uriNCM}/${numNCM}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => err);
  },
  async getAlteracoesDaNCM(ncm) {
    return axios.get(`${uri}/${uriAlteracoesDaNCM}/${ncm}/${tok}`).then(
      res => {
        return res.data;
      },
      err => {
        return "-1";
      }
    );
  },

  async getHistoricoNCMs() {
    return axios.get(`${uri}/${uriAlteracoesDaNCM}/${tok}`).then(
      res => {
        return res.data;
      },
      err => {
        return err.response;
      }
    );
  }
};
